$(document).on("turbolinks:load", function () {
  $(".tools-tabitem").click(function () {
    $(".tools-tabitem1").removeClass("selected-tab-items");
    $("#tools-for-prarents-and-students").show();
    $(".tools-tabitem").addClass("selected-tab-items");
    $("#tools-chairperson-rewards-container").hide();
  });

  $(".tools-tabitem1").click(function () {
    $(".tools-tabitem").removeClass("selected-tab-items");
    $("#tools-for-prarents-and-students").hide();
    $(".tools-tabitem1").addClass("selected-tab-items");
    $("#tools-chairperson-rewards-container").show();
    $("#tools-chairperson-rewards-container").css("display", "flex");
  });

  if ($("#manage-students-container").length) {
    $("#manage-students-container, #student-metrics-table-search").hide();
  }
  if ($("#manage-chair-container").length) {
    $("#manage-chair-container").hide();
  }
  if ($("#sub-details-tab").length) {
    $("#sub-details-tab").hide();
  }
  if ($("#invitations-chair-container").length) {
    $("#invitations-chair-container").hide();
  }
  if ($("#payment_information_box").length) {
    $("#payment_information_box").hide();
  }
  if ($("#manage-custom-categories-container").length) {
    $("#manage-custom-categories-container").hide();
  }

  $(".details-tabitem").click(function () {
    $(
      ".details-tabitem1, .details-tabitem2, .details-tabitem3, .details-tabitem4"
    ).removeClass("selected-tab-items");
    $(".details-tabitem").addClass("selected-tab-items");
    $("#update-fundraiser-block").show();
    $(
      "#manage-students-container, #student-metrics-table-search, #manage-chair-container, #invitations-chair-container, #sub-details-tab, #payment_information_box, #manage-custom-categories-container"
    ).hide();
  });

  $(".details-tabitem1").click(function () {
    $(
      ".details-tabitem, .details-tabitem2, .details-tabitem3, .details-tabitem4"
    ).removeClass("selected-tab-items");
    $(".details-tabitem1").addClass("selected-tab-items");
    $(
      "#update-fundraiser-block, #manage-chair-container, #invitations-chair-container, #sub-details-tab, #payment_information_box, #manage-custom-categories-container"
    ).hide();
    $("#manage-students-container, #student-metrics-table-search").show();
  });

  $(".details-tabitem2").click(function () {
    $(
      ".details-tabitem, .details-tabitem1, .details-tabitem3, .details-tabitem4"
    ).removeClass("selected-tab-items");
    $(".details-tabitem2").addClass("selected-tab-items");
    $(
      "#update-fundraiser-block, #manage-students-container, #student-metrics-table-search, #payment_information_box, #manage-custom-categories-container"
    ).hide();
    $("#sub-details-tab").show();
    $("#manage-chair-container").show();
    $("li").removeClass("current");
    $("li").removeClass("current-sel");
    $("#manage-chair-a2").parent("li").addClass("current");
    $("#manage-chair-a2").parent("li").addClass("current-sel");
  });

  $(".details-tabitem3").click(function () {
    $(
      ".details-tabitem, .details-tabitem1, .details-tabitem2, .details-tabitem4"
    ).removeClass("selected-tab-items");
    $(".details-tabitem3").addClass("selected-tab-items");
    $(
      "#update-fundraiser-block, #manage-custom-categories-container,  #manage-students-container, #student-metrics-table-search, #student-metrics-table-search, #manage-chair-container, #invitations-chair-container, #sub-details-tab"
    ).hide();
    $("#payment_information_box").show();
  });

  $(".details-tabitem4").click(function () {
    $(
      ".details-tabitem, .details-tabitem1, .details-tabitem2, .details-tabitem3"
    ).removeClass("selected-tab-items");
    $(".details-tabitem4").addClass("selected-tab-items");
    $(
      "#update-fundraiser-block, #manage-chair-container, #invitations-chair-container, #sub-details-tab, #payment_information_box, #manage-students-container, #student-metrics-table-search"
    ).hide();
    $("#manage-custom-categories-container").show();
  });

  $(document)
    .find("#edit_campaign_cancel_button")
    .on("click", function (e) {
      let form = $(document).find(".edit_campaign");
      form.trigger("reset");
      updateButtons();
    });

  $(document).on("click", "button#copy-invite-url", function (e) {
    e.preventDefault();
    var copyText = $(this).data("invitation-value");
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = copyText;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    showFlashMessage("Link copied to clipboard!");
  });

  $(document).on("click", "button#resend-sign-up-email", function (e) {
    e.preventDefault();
    var invitationId = $(this).data("invitation-id");
    var host = window.location.host;
    var basePath = window.location.pathname.split("/")[1];
    $.ajax({
      url:
        "//" +
        host +
        "/" +
        basePath +
        "/administrators/" +
        invitationId +
        "/resend_chairperson_invitation",
      type: "POST",
      success: function (response) {
        display_alert(response["message"], "Chairperson successfully invited");
      },
      error: function () {
        console.log("Error occurred while inviting chairperson");
      },
    });
  });

  $("#copy-sign-up-middle").on("click", function () {
    let copyText = document.getElementById("copy-sign-up-middle").value;

    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = copyText;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    showFlashMessage("Link copied to clipboard!");
  });

  $("#copy-video-link-middle").on("click", function () {
    let copyText = document.getElementById("copy-video-link-middle").value;

    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = copyText;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    showFlashMessage("Link copied to clipboard!");
  });

  $("#copy-sign-up-url").on("click", function () {
    let copyText = document.getElementById("copy-sign-up-url").value;
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = copyText;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    showFlashMessage("Link copied to clipboard!");
  });

  $("#middle-widdyup-video-link").on("click", function () {
    var copyText = document.getElementById("middle-widdyup-video-link").value;
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = copyText;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    showFlashMessage("Link copied to clipboard!");
    // showplaceholder();
  });

  function showplaceholder() {
    // Create a placeholder element
    var placeholder = $(
      '<div class="placeholder1">Link copied to clipboard!</div>'
    );

    // Set its position to the current cursor position
    placeholder.css({
      left: event.pageX + 10 + "px",
      top: event.pageY + 10 + "px",
    });

    // Append the placeholder to the document body
    $("body").append(placeholder);

    // Fade out and remove the placeholder after 2 seconds
    setTimeout(function () {
      placeholder.fadeOut(300, function () {
        $(this).remove();
      });
    }, 1000);
  }
  function showFlashMessage(message) {
    var notificationTimer;
    $(".notification-container.alert-success").find("span").html(message);
    $(".notification-container.alert-success").css("display", "flex");
    $(".notification-container.alert-success")[0].classList.add(
      "animate__animated",
      "animate__bounceIn"
    );
    clearTimeout(notificationTimer);
    notificationTimer = 0;
    notificationTimer = setTimeout(function () {
      $(".notification-container.alert-success").css("display", "none");
      $(".notification-container.alert-success")[0].classList.remove(
        "animate__animated",
        "animate__bounceIn"
      );
    }, 1000);
  }

  // Get the form element
  var form = document.getElementById("user-profile-update-width");
  var saveButton = document.getElementById("edit_campaign_save_button");
  var cancelButton = document.getElementById("edit_campaign_cancel_button");

  if (form && saveButton && cancelButton) {
    saveButton.disabled = true;
    cancelButton.classList.add("disabled");
    cancelButton.setAttribute("disabled", "disabled");

    // Get the initial form values
    var initialFormValues = getFormValues(form);

    // Attach a MutationObserver to the form element to track changes
    var mutationObserver = new MutationObserver(function (mutationsList) {
      for (var mutation of mutationsList) {
        if (
          mutation.type === "childList" ||
          (mutation.type === "attributes" && mutation.attributeName === "value")
        ) {
          updateButtons();
        }
      }
    });
    mutationObserver.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value"],
    });

    // Attach a "change" event listener to the form
    form.addEventListener("input", function () {
      updateButtons();
    });
  }

  function getFormValues(form) {
    var values = {};
    var inputs = form.querySelectorAll("input, textarea, select");
    inputs.forEach(function (input) {
      values[input.name] = input.value;
    });
    return values;
  }

  function updateButtons() {
    var currentFormValues = getFormValues(form);
    var hasChanges = compareFormValues(initialFormValues, currentFormValues);

    saveButton.disabled = !hasChanges;
    if (hasChanges) {
      cancelButton.classList.remove("disabled");
      cancelButton.removeAttribute("disabled");
    } else {
      cancelButton.classList.add("disabled");
      cancelButton.setAttribute("disabled", "disabled");
    }
  }

  function compareFormValues(values1, values2) {
    var keys1 = Object.keys(values1);
    var keys2 = Object.keys(values2);
    if (keys1.length !== keys2.length) {
      return true;
    }
    for (var i = 0; i < keys1.length; i++) {
      var key = keys1[i];
      if (values1[key] !== values2[key]) {
        return true;
      }
    }
    return false;
  }

  $(".custom-file-input-pitch").on("click", function () {
    $("#upload-pitch-dialog").fadeIn("slow");
  });

  $(".custom-file-input-widdyup").on("click", function () {
    document.querySelector(".widdyup-video-file-input").click();
  });

  $(".widdyup-video-file-input, .pitch-video-file-input").on(
    "change",
    function (e) {
      let form = $(document).find(".update-fundraiser-video-form");
      modal = $(this)
        .parents(".update-fundraiser-container")
        .find(".upload-video-modal");
      content = modal.find(".upload-video-content");
      modal.css("display", "flex");
      content.css("display", "flex");
      form.trigger("submit");
    }
  );

  $("#upload_pitch_cancel_button").on("click", function () {
    $(".upload-pitch-modal").css("display", "none");
  });

  $("#submit-upload-pitch-request").on("click", function () {
    document.querySelector(".pitch-video-file-input").click();
  });

  $(
    "#allow_students_to_override_pitch, #allow_students_to_override_widdyup"
  ).on("change", function () {
    if ($(this).prop("checked")) {
      $("#update-override-dialog .text").text(
        "Confirm that your students can override the group video(s) by uploading a personal video."
      );
    } else {
      $("#update-override-dialog .text").text(
        "Confirm that your students will not be allowed to override the group video(s) with a personal video."
      );
    }
    $("#update-override-dialog").fadeIn("slow");
  });

  $("#submit-override-request").on("click", function () {
    let form = $(document).find(".update-fundraiser-video-form");
    form.trigger("submit");
  });

  $("#pagination-content").on("click", function () {
    $(document).on("turbolinks:load", function () {
      if ($(".details-tabitem1").length) {
        $(".details-tabitem1").click();
        var tableElement = document.getElementById("manage-students-container");
        tableElement.scrollIntoView({ behavior: "smooth" });
      } else if ($(".student-metrics").length) {
        var tableElement =
          document.getElementsByClassName("student-metrics")[0];
        tableElement.scrollIntoView({ behavior: "smooth" });
      }
    });
  });

  $(".district-page-content").on(
    "click",
    "#edit_student_cancel_button",
    function () {
      $(".student-edit-modal").css("display", "none");
    }
  );

  $("#override_cancel_button").on("click", function () {
    let form = $(document).find(".update-fundraiser-video-form");
    form.trigger("reset");
    $(".override-dialog-modal").css("display", "none");
  });

  $("#edit_chair_cancel_button").on("click", function () {
    $(".chair-edit-modal").css("display", "none");
  });

  $("#edit_chair_invi_cancel_button").on("click", function () {
    $(".chair-invitation-edit-modal").css("display", "none");
  });

  $("#add_chair_cancel_button").on("click", function () {
    $("#add-chair-modal").css("display", "none");
  });

  $("#paper_check_cancel_button").on("click", function () {
    $("#check-paper-modal").css("display", "none");
  });

  $(".district-page-content").on(
    "click",
    ".student-metrics-table .table-data .edit-student-button",
    function () {
      var studentId = $(this).data("student-id");
      let campaignId = $(this).data("campaign-id");
      $("#edit-student-id").val(studentId);
      var host = window.location.host;
      var basePath = window.location.pathname.split("/")[1];
      $("#category-fields .row").show();
      $.ajax({
        url:
          "//" +
          host +
          "/" +
          basePath +
          "/students/" +
          studentId +
          "/edit?campaign_id=" +
          campaignId,
        type: "GET",
        success: function (response) {
          $("#edit-student-first-name").val(response.first_name);
          $("#edit-student-last-name").val(response.last_name);
          $("#edit-student-email").val(response.email);
          $("#edit-student-phone-number").val(response.phone_number);
          $("#edit-student-school").val(response.school);
          $("#edit-student-grade").val(response.grade);
          $("#category-fields select").each(function (index, element) {
            if (!response.categories[index]) {
              $(element).closest(".row").hide();
            } else {
              $(element).val(response.categories[index]?.id);
            }
          });
          $("#category-fields input").each(function (index, element) {
            $(element).val(response.categories[index]?.id);
          });
          $("#edit-student-modal").fadeIn("slow");
        },
        error: function () {
          console.log("Error occurred while fetching student details");
        },
      });
    }
  );

  $(".edit-custom-category-button").on("click", function () {
    const customCategoryId = $(this).data("category-id");
    const campaignId = $(this).data("campaign-id");
    $("#update-category-form  #edit-custom-category-id").val(customCategoryId);
    const host = window.location.host;
    const basePath = window.location.pathname.split("/")[1];
    $.ajax({
      url: `//${host}/${basePath}/campaigns/${campaignId}/campaign_custom_categories/${customCategoryId}`,
      type: "GET",
      success: function (response) {
        $("#update-category-form #category-name-field").val(
          response.custom_category.name
        );

        const optionsContainer = $("#update-category-form #options");
        optionsContainer.empty();
        response.options.forEach(function (option, index) {
          const optionIndex = index + 1;
          const closeIconPath = optionsContainer.data("close-icon");
          const optionContainer = $("<div>").addClass("option-container");
          const optionDiv = $("<div>")
            .addClass("form-group")
            .attr("id", `option-${optionIndex}`);

          const label = $("<label>")
            .attr({
              for: `option-input-${optionIndex}`,
              class: "category-form-label",
            })
            .text(`Option #${optionIndex}`);
          const input = $("<input>").attr({
            type: "text",
            name: "options[][name]",
            id: `option-input-${optionIndex}`,
            class: "category-form-value",
            value: option.name,
          });
          const hiddenInput = $("<input>").attr({
            type: "hidden",
            name: "options[][id]",
            id: "option-id",
            value: option.id,
          });
          const button = $("<button>")
            .addClass("remove-option")
            .attr({
              type: "button",
              "data-target": `#option-${optionIndex}`,
              "data-option-id": option.id,
            })
            .append($("<img>").attr("src", closeIconPath));

          optionDiv.append(label, input, hiddenInput);
          optionContainer.append(optionDiv, button);
          optionsContainer.append(optionContainer);
        });
        $("#edit-custom-category-modal").fadeIn("slow");
      },
      error: function () {
        console.log("Error occurred while fetching custom category details");
      },
    });
  });

  $(".edit-chair-button").on("click", function () {
    var adminId = $(this).data("admin-id");
    $("#edit-chair-id").val(adminId);
    var host = window.location.host;
    var basePath = window.location.pathname.split("/")[1];
    $.ajax({
      url:
        "//" + host + "/" + basePath + "/administrators/" + adminId + "/edit",
      type: "GET",
      success: function (response) {
        $("#edit-chair-first-name").val(response.first_name);
        $("#edit-chair-last-name").val(response.last_name);
        $("#edit-chair-email").val(response.email);
        $("#edit-chair-phone-number").val(response.phone_number);
        $("#edit-chair-school").val(response.school);
        $("#edit-chair-modal").fadeIn("slow");
      },
      error: function () {
        console.log("Error occurred while fetching admin details");
      },
    });
  });

  $(".change-to-paper-check-button, #paper-check-edit").on(
    "click",
    function () {
      $("#check-paper-modal").fadeIn("slow");
    }
  );

  $(".edit-chair-invi-button").on("click", function () {
    var invitationId = $(this).data("invitation-id");
    $("#edit-chair-invi-id").val(invitationId);
    var host = window.location.host;
    var basePath = window.location.pathname.split("/")[1];
    $.ajax({
      url:
        "//" +
        host +
        "/" +
        basePath +
        "/administrators/" +
        invitationId +
        "/edit_invitation",
      type: "GET",
      success: function (response) {
        $("#edit-chair-invi-first-name").val(response.first_name);
        $("#edit-chair-invi-last-name").val(response.last_name);
        $("#edit-chair-invi-email").val(response.email);
        $("#edit-chair-invi-phone-number").val(response.phone_number);
        $("#edit-chair-invi-school").val(response.school);
        $("#edit-chair-invi-modal").fadeIn("slow");
      },
      error: function () {
        console.log("Error occurred while fetching chair invitation details");
      },
    });
  });

  $(".add-chairperson-class").on("click", function () {
    var school_name = $('input[name="school"]').val();
    $("#add-chair-school").val(school_name);
    $("#add-chair-modal").fadeIn("slow");
  });

  $(".add-custom-category-class").on("click", function () {
    $("#add-custom-category-modal").fadeIn("slow");
  });

  $(".dashboard-content-container").on("click", ".students-metrics__add_category", function () {
    $("#add-custom-category-modal").fadeIn("slow");
  });

  $(".validate_empty_string").on("input", function () {
    var txt = $(this).val().trim();
    if (txt.length === 0) {
      $(this)[0].setCustomValidity("Please fill in this field.");
      $(this)[0].reportValidity();
    } else {
      $(this)[0].setCustomValidity("");
    }
  });

  $("#campaign_purpose").on("input", function () {
    var txt = $(this).val().trim();
    if (txt.length > 120) {
      $(this)[0].setCustomValidity("Exceeded maximum character limit of 120.");
      $(this)[0].reportValidity();
    } else {
      $(this)[0].setCustomValidity("");
    }
  });

  var storedTabIndex = localStorage.getItem("activeTabIndex");
  var notificationValue = $(".notification-container .notification").text();
  if (storedTabIndex !== null && storedTabIndex == "tab-2") {
    if ($(".details-tabitem1").length) {
      $(".details-tabitem1").click();
      localStorage.removeItem("activeTabIndex");
    }
  } else if (storedTabIndex !== null && storedTabIndex == "tab-3") {
    if ($(".details-tabitem2").length) {
      $(".details-tabitem2").click();
      localStorage.removeItem("activeTabIndex");
      $("li").removeClass("current");
      $("li").removeClass("current-sel");
      $("#manage-chair-a1").parent("li").addClass("current");
      $("#manage-chair-a1").parent("li").addClass("current-sel");
      $("#manage-chair-container").hide();
      $("#invitations-chair-container").show();
    }
  } else if (storedTabIndex !== null && storedTabIndex == "tab-3-2") {
    if ($(".details-tabitem2").length) {
      $(".details-tabitem2").click();
      localStorage.removeItem("activeTabIndex");
      $("li").removeClass("current");
      $("li").removeClass("current-sel");
      $("#manage-chair-a2").parent("li").addClass("current");
      $("#manage-chair-a2").parent("li").addClass("current-sel");
      $("#manage-chair-container").show();
      $("#invitations-chair-container").hide();
    }
  } else if (storedTabIndex !== null && storedTabIndex == "tab-4") {
    if ($(".details-tabitem3").length) {
      $(".details-tabitem3").click();
      localStorage.removeItem("activeTabIndex");
    }
  } else if (storedTabIndex !== null && storedTabIndex == "tab-5") {
    if ($(".details-tabitem3").length) {
      $(".details-tabitem3").click();
      localStorage.removeItem("activeTabIndex");
    }
  } else if (
    notificationValue !== null &&
    notificationValue == "Payment information successfully updated."
  ) {
    if ($(".details-tabitem3").length) {
      $(".details-tabitem3").click();
      localStorage.removeItem("activeTabIndex");
    }
  }

  $("#manage-chair-a2").click(function () {
    $("li").removeClass("current");
    $("li").removeClass("current-sel");
    $(this).parent("li").addClass("current");
    $(this).parent("li").addClass("current-sel");
    $("#manage-chair-container").show();
    $("#invitations-chair-container").hide();
  });

  $("#manage-chair-a1").click(function () {
    $("li").removeClass("current");
    $("li").removeClass("current-sel");
    $(this).parent("li").addClass("current");
    $(this).parent("li").addClass("current-sel");
    $("#manage-chair-container").hide();
    $("#invitations-chair-container").show();
  });

  $("#delete-group-pitch-trigger").click(function () {
    $(document.body).css("overflow", "hidden");
    $("#remove-group-pitch-dialog").css("display", "block");
  });

  $("#group-pitch-change-video-trigger").click(function () {
    document.querySelector(".pitch-video-file-input").click();
  });

  $("#delete-group-widdyup-trigger").click(function () {
    $(document.body).css("overflow", "hidden");
    $("#remove-group-final-dialog").css("display", "block");
  });

  $("#group-widdyup-change-video-trigger").click(function () {
    document.querySelector(".widdyup-video-file-input").click();
  });

  $(document).on(
    "click",
    '[data-element-type="remove-group-pitch"]',
    function () {
      let button = $(this);
      button.prop("disabled", true);
      button.addClass("btn-disabled");
      button.removeClass("v2-btn-blue");
      button.text("Please wait...");
      Rails.ajax({
        type: "DELETE",
        url: `delete_group_pitch_video`,
        success: (response) => {
          display_alert(response["message"], "success");
          setTimeout(function () {
            location.reload();
          }, 1000);
        },
      });
    }
  );

  $(document).on(
    "click",
    '[data-element-type="remove-group-final"]',
    function () {
      let button = $(this);
      button.prop("disabled", true);
      button.addClass("btn-disabled");
      button.removeClass("v2-btn-blue");
      button.text("Please wait...");
      Rails.ajax({
        type: "DELETE",
        url: `delete_group_final_video`,
        success: (response) => {
          $("#remove-group-final-dialog").fadeOut("slow");
          display_alert(response["message"], "success");
          setTimeout(function () {
            location.reload();
          }, 1000);
        },
        error: (response) => {
          $("#remove-group-final-dialog").fadeOut("slow");
          display_alert(response["alert"], "error");
          setTimeout(function () {
            location.reload();
          }, 1000);
        },
      });
    }
  );

  function display_alert(message, type) {
    let alert = $(`.campaign-name-1 .alert-${type}`);

    alert.find("span").html(message);
    alert.css("display", "flex");
    alert[0].classList.add("animate__animated", "animate__bounceIn");

    setTimeout(function () {
      alert.css("display", "none");
      alert[0].classList.remove("animate__animated", "animate__bounceIn");
    }, 3000);
  }
});
